import { cx } from "@jugl-web/utils";
import { useTheme } from "@web-src/themes/useTheme";
import { HTMLAttributes, forwardRef } from "react";

interface NavbarButtonProps extends HTMLAttributes<HTMLButtonElement> {
  isActive?: boolean;
}

export const NavbarButton = forwardRef<HTMLButtonElement, NavbarButtonProps>(
  ({ isActive = false, className, ...props }, ref) => {
    const { tcx } = useTheme();

    return (
      <button
        ref={ref}
        type="button"
        className={tcx(
          "jugl__focusable-outline flex h-8 cursor-pointer items-center overflow-hidden rounded-2xl border-0 px-[18px] font-secondary text-sm font-medium text-white transition-colors",
          {
            blue: cx(
              "bg-[#10439A] hover:bg-[#0E357A]",
              isActive && "bg-[#0E357A]"
            ),
            light: cx(
              "bg-primary-800 hover:bg-primary-900",
              isActive && "bg-primary-900"
            ),
            dark: cx(
              "bg-[#3E3F40] hover:bg-[#333333]",
              isActive && "bg-[#333333]"
            ),
          },
          className
        )}
        {...props}
      />
    );
  }
);
